import React from "react";

export const handleContainerClick =
  (buttonId: string, textareaId: string) =>
  (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target;
    // Guard with instanceof Element because event.target can be null or a text node,
    // neither of which has .closest(). CSS.escape() prevents a SyntaxError when
    // buttonId contains characters that are invalid in a CSS selector (e.g. ".", ":").
    if (
      target instanceof Element &&
      target.closest(`#${CSS.escape(buttonId)}`)
    ) {
      return;
    }
    document.getElementById(textareaId)?.focus();
  };
